import { useOutletContext } from "react-router-dom";

/**
 * 全ページ共通のブランディング制御フック
 * AppLayout または QuotationViewPage から渡される context を利用します
 */
export const useBranding = () => {
  // AppLayout の Outlet context から情報を取得
  const context = useOutletContext() || {};
  const { oemBranding, user } = context;
  const isOem = !!(oemBranding || user?.oem_id);

  return {
    // 表示用サービス名：OEM設定があればそれ、なければ本家名
    appName: oemBranding?.display_name || (isOem ? "Partner Portal" : "Sales Breaker"),
    
    // ロゴURL：OEM設定のパスを優先
    logoUrl: oemBranding?.logo_path ? `${window.location.origin}/api/oem${oemBranding.logo_path}` : null,
    
    // ブランドカラー
    brandColor: oemBranding?.brand_color || "#2563eb",
    
    // OEMユーザーかどうか
    isOem
  };
};
